import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PREMIUM_PAGE } from "../../../../../Constants/routesConstant";
import { isTimerExpired, redirectToDashy } from "../../../../../Utils/common";
import { useCountdownHook } from "../../../../../Utils/countdownTimerHook";
import { getDLPThemeUpsellDiscount, showThemeUpsellTimer } from "../../../utils/common";
import { DLP_HERO_SECTION_IMAGE } from "../../../utils/constant";
import { OfferStripIcon } from "../../../utils/svgIcons";

const PrimaryCTA = ({ children, className, onClick }) => {
  return (
    <button
      className={`tw-cursor-pointer tw-rounded-lg tw-border-none tw-bg-blue-three tw-px-4 tw-py-[16px] tw-font-jakarta hover:tw-bg-[#215BA8] ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

const OfferStrip = ({ callback = null }) => {
  const { bannerInfo } = useSelector((state) => ({
    bannerInfo: state.staffManagementReducer?.staffMemberData?.banner_info,
  }));
  const [showTimerCTA, setShowTimerCTA] = useState(true);
  const [hour, minute, second] = useCountdownHook(bannerInfo?.expiry_time || "");
  
  useEffect(() => {
    if (isTimerExpired(hour, minute, second)) {
      setShowTimerCTA(false);
    } else {
      setShowTimerCTA(true);
    }
  }, [hour, minute, second]);

  const redirectToPremiumPage = () => {
    callback && callback();
    redirectToDashy(PREMIUM_PAGE);
  };

  if (!showThemeUpsellTimer() || !showTimerCTA) {
    return (
      <PrimaryCTA className="tw-mt-8 tw-px-5 tw-py-[17px]" onClick={redirectToPremiumPage}>
        <span className="tw-text-[16px] tw-font-bold tw-leading-5 tw-text-white desktop:tw-text-[18px]">
          Explore Website Designs
        </span>
      </PrimaryCTA>
    );
  }

  return (
    <div className="tw-mt-6 tw-flex tw-flex-col tw-gap-5 tw-rounded-lg tw-bg-[#DAEDEA] tw-px-7 tw-pb-4 tw-pt-[26px] tw-text-[#1E6A26]">
      <div className="tw-flex">
        <div className="tw-mr-2 tw-flex tw-items-start tw-pt-1">
          <OfferStripIcon />
        </div>
        <div className="tw-text-sm tw-font-semibold tw-leading-6">
          <span className="tw-font-bold">Limited time offer</span> - Get ₹{getDLPThemeUpsellDiscount()} off on
          professionally-designed websites.
        </div>
      </div>
      <PrimaryCTA className="tw-w-full" onClick={redirectToPremiumPage}>
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-text-white">
          <span className="tw-text-[16px] tw-font-bold tw-leading-5 desktop:tw-text-[18px]">Avail Offer</span>
          <span className="tw-text-[16px] tw-font-medium tw-leading-5 desktop:tw-text-[17px]">
            Offer ends in -
            <span style={{ fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"' }}>
              {hour !== "00" && `${hour}h: `} {minute}m : {second}s
            </span>{" "}
          </span>
        </div>
      </PrimaryCTA>
    </div>
  );
};

const LeftSection = ({ callback = null }) => {
  return (
    <div className="tw-font-jakarta">
      <section className="tw-mb-4">
        <span className="tw-text-base tw-font-semibold">Do more with Digital Showroom</span>
      </section>
      <div className="tw-mb-6 tw-flex tw-flex-col tw-text-[40px] tw-font-bold tw-leading-[50px] desktop:tw-text-5xl desktop:tw-leading-[56px]">
        <span>Give a home to</span>
        <span>your domain</span>
      </div>
      <div className="tw-text-base tw-font-medium">
        <p className="tw-m-0 tw-max-w-[80%]">
          Transform your new domain into a stunning website with our beautiful, easy-to-use designs!
        </p>
      </div>
      <OfferStrip callback={callback} />
    </div>
  );
};

const RightSection = () => {
  return (
    <div className="tw-flex tw-flex-shrink-0 tw-items-end">
      <img src={DLP_HERO_SECTION_IMAGE} className="tw-h-[370px]" loading="lazy" />
    </div>
  );
};

const DLPPostPurchaseHeroSection = ({ callback = null }) => {
  return (
    <div className="tw-font-jakarta">
      <section className="tw-flex tw-items-end tw-justify-between tw-gap-12">
        <LeftSection callback={callback} />
        <RightSection />
      </section>
    </div>
  );
};

export default DLPPostPurchaseHeroSection;
